module.exports = __webpack_public_path__ + "img/75683.57257fb9.svg";